"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailability = void 0;
var AvailabilityStatus;
(function (AvailabilityStatus) {
    AvailabilityStatus["Backorder"] = "BACKORDER";
    AvailabilityStatus["Discontinued"] = "DISCONTINUED";
    AvailabilityStatus["NewVersionAvailable"] = "NEW_VERSION_AVAILABLE";
    AvailabilityStatus["OutOfStock"] = "OUT_OF_STOCK";
    AvailabilityStatus["TemporarilyUnavailable"] = "TEMPORARILY_UNAVAILABLE";
})(AvailabilityStatus || (AvailabilityStatus = {}));
const getAvailability = (inStock, availabilityStatus) => {
    if (inStock) {
        return 'https://schema.org/InStock';
    }
    if (availabilityStatus === AvailabilityStatus.Backorder) {
        return 'https://schema.org/BackOrder';
    }
    if (availabilityStatus === AvailabilityStatus.Discontinued) {
        return 'https://schema.org/Discontinued';
    }
    return 'https://schema.org/OutOfStock';
};
exports.getAvailability = getAvailability;
//# sourceMappingURL=schema-utils.js.map